<template>
	<div class="full page_container">
		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="新品立项" v-if="findChildren(171)!==-1" name="newgoodsapproval" style="height: 100%;">
				<newgoodsapproval-index />
			</el-tab-pane>
			<el-tab-pane label="新品登记" v-if="findChildren(120)!==-1" name="newgoodsrecord" style="height: 100%;">
				<newgoodsrecord-index />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import newgoodsapprovalIndex from './newgoodsapproval/index.vue'
	import newgoodsrecordIndex from './newgoodsrecord/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: [],

			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'goods'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			},
		},
		components: {
			newgoodsapprovalIndex,
			newgoodsrecordIndex
		}
	}
</script>